/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { classNames } from '../utils/UNSAFE_classNames';
import { useUser } from '../hooks/UNSAFE_useUser';
import { ColorProps } from '../utils/UNSAFE_interpolations/colors';
import { DvtThresholdsColors, getDvtThresholdColor } from '../utils/UNSAFE_dvtCommonUtils';
import { styles } from './themes/MeterBarStyles.css';

type ReferenceLineProps = {
  orientation: 'horizontal' | 'vertical';
  percentage: string;
  position?: 'start' | 'end';
  color?: ColorProps['color'] | DvtThresholdsColors;
};

export function ReferenceLineBar({ orientation, percentage, color, position }: ReferenceLineProps) {
  const isHoriz = orientation === 'horizontal';
  const { direction } = useUser();
  const isRtl = direction === 'rtl';
  const isStartPos = position === 'start';

  return (
    <div
      class={classNames([
        styles.referenceLinesBaseStyle,
        isHoriz ? styles.referenceLinesHorizontalStyle : styles.referenceLinesVerticalStyle,
        isStartPos
          ? isHoriz
            ? styles.referenceLinesHoriontalStartStyle
            : isRtl
            ? styles.referenceLinesVerticalStartRtlStyle
            : styles.referenceLinesVerticalStartLtrStyle
          : ''
      ])}
      style={{
        left: isHoriz && !isRtl ? percentage : undefined,
        right: isHoriz && isRtl ? percentage : undefined,
        bottom: isHoriz ? undefined : percentage,
        backgroundColor: getDvtThresholdColor(color)
      }}></div>
  );
}
